<template>
    <div id="prev">
        <a v-if="disabled" class="disabled item">
            <i class="angle left icon"></i>
        </a>
        <a v-else-if="page" class="item" @click="change_page">
            <i class="angle left icon"></i>
        </a>
        <a v-else class="disabled item">
            <i class="angle left icon"></i>
        </a>
    </div>
</template>

<script>
export default {
    name: "PaginationPrevious",
    props: {
        page: Number,
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
        }
    },
    mounted() {
    },
    computed: {
    },
    methods: {
        change_page() {
            this.$parent.change_page(this.page)
        }
    },
    components: {
    }
}
</script>

<style scoped>
</style>
